import { Component, OnInit, Inject, Injectable } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { LayerService } from "../../services/layers/layer.service";
import { CategoryService } from "../../services/category_layers/category.service";
import { FormService } from "../../services/forms/form.service";
import { FieldFormService } from "../../services/forms/field-form.service";

@Component({
  selector: "app-modal-layer",
  templateUrl: "./modal-layer.component.html",
  styleUrls: ["./modal-layer.component.css"]
})
export class ModalLayerComponent implements OnInit {
  id: any;
  name: any;
  category: any;
  geometry: any;
  description: any;
  categories: any;
  hash: any;
  action_type: any;
  geometries: any[] = [
    {
      value: "1",
      description: "Línea"
    },
    {
      value: "2",
      description: "Punto"
    },
    {
      value: "3",
      description: "Polígono"
    }
  ];

  constructor(
    protected layerService: LayerService,
    protected formService: FormService,
    protected fieldFormService: FieldFormService,
    protected categoryService: CategoryService,
    private dialogRef: MatDialogRef<ModalLayerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.categoryService.getCategories().subscribe((data: {}) => {
      this.categories = data;
    });

    this.action_type = "create";

    if (typeof data.data !== "undefined") {
      this.id = data.data.capa_id;
      this.name = data.data.capa_nombre;
      this.category = data.data.categoria_capa_id;
      this.geometry = data.data.geometria_capa_id;
      this.description = data.data.capa_nombre_descripcion;
      this.hash = data.data.gx_md5_hash;
      this.action_type = "edit";
    }
  }

  ngOnInit() {}

  public closeMe() {
    this.dialogRef.close();
  }

  public createLayer() {
    const layerDetails = {
      geometria_capa_id: this.geometry,
      categoria_capa_id: this.category,
      capa_nombre: this.name,
      capa_nombre_descripcion: this.description,
      capa_nombre_estado: "1"
    };

    this.layerService.createLayer(layerDetails).subscribe((data: {}) => {
      this.dialogRef.close({ data: data });
    });
  }

  public editLayer() {
    const layerDetails = {
      capa_id: this.id,
      geometria_capa_id: this.geometry,
      categoria_capa_id: this.category,
      capa_nombre: this.name,
      capa_nombre_descripcion: this.description,
      capa_nombre_estado: "1",
      gx_md5_hash: this.hash
    };

    this.layerService
      .updateLayer(this.id, layerDetails)
      .subscribe((data: {}) => {
        this.dialogRef.close({ data: data });
      });
  }
}
